import { atom } from "jotai";
import { 
  createOrUpdateConstructionSequence,
  getAllConstructionSequence, 
  deleteConstructionSequence as deleteConstructionSequenceService 
} from "../../services/construction/constructionSequenceService";

export const constructionSequenceAtom = atom({
  sequences: [],
  loading: false,
  error: null
});

export const fetchConstructionSequences = atom(
  null,
  async (_, set) => {
    try {
      set(constructionSequenceAtom, (prev) => ({ ...prev, loading: true, error: null }));
      const response = await getAllConstructionSequence();
      set(constructionSequenceAtom, (prev) => ({
        ...prev,
        sequences: response || [],
        loading: false,
        error: null
      }));
    } catch (error) {
      set(constructionSequenceAtom, (prev) => ({
        ...prev,
        loading: false,
        error: error.message || 'Failed to fetch sequences'
      }));
    }
  }
);

export const updateConstructionSequences = atom(
  null,
  async (_, set, sequenceDataArray) => {
    try {
      set(constructionSequenceAtom, (prev) => ({ ...prev, loading: true, error: null }));

      const sequencesToSave = sequenceDataArray.map((seq) => {
        const payload = {
          sequence: seq.sequence,
          start_time: seq.start_time,
          end_time: seq.end_time,
          block_id: seq.block_id,
          color: seq.color || '#FFFF00',
        };

        if (seq.id !== null && seq.id !== undefined && seq.id !== 'null' && seq.id !== '') {
          payload.id = seq.id;
        }

        return payload;
      });

      if (sequencesToSave.length > 0) {
        await createOrUpdateConstructionSequence(sequencesToSave);
      }

      const updatedSequences = await getAllConstructionSequence();
      set(constructionSequenceAtom, (prev) => ({
        ...prev,
        sequences: updatedSequences || [],
        loading: false,
        error: null,
      }));
    } catch (error) {
      set(constructionSequenceAtom, (prev) => ({
        ...prev,
        loading: false,
        error: error.message || 'Failed to update sequences',
      }));
      throw error;
    }
  }
);

export const deleteConstructionSequenceAtom = atom(
  null,
  async (_, set, sequenceToDelete) => {
    try {
      set(constructionSequenceAtom, (prev) => ({ ...prev, loading: true, error: null }));
      
      try {
        const payload = {
          id: sequenceToDelete.id,
          sequence: sequenceToDelete.sequence || 1,
          start_time: sequenceToDelete.startWeek || sequenceToDelete.start_time || 0,
          end_time: sequenceToDelete.endWeek || sequenceToDelete.end_time || 0,
          block_id: sequenceToDelete.blockId || sequenceToDelete.block_id,
          color: sequenceToDelete.color || '#FFFF00',
          delete: true
        };
        // eslint-disable-next-line
        const response = await createOrUpdateConstructionSequence([payload]);
        
        const updatedSequences = await getAllConstructionSequence();
        const stillExists = updatedSequences.find(seq => seq.id === sequenceToDelete.id);
        
        if (stillExists) {
          throw new Error('POST delete method failed');
        }
        
        set(constructionSequenceAtom, (prev) => ({
          ...prev,
          sequences: updatedSequences || [],
          loading: false,
          error: null,
        }));
        
        return { success: true, method: 'POST' };
        
      } catch (postError) {
        // eslint-disable-next-line
        const deleteResponse = await deleteConstructionSequenceService(sequenceToDelete.id);
        
        const updatedSequences = await getAllConstructionSequence();
        set(constructionSequenceAtom, (prev) => ({
          ...prev,
          sequences: updatedSequences || [],
          loading: false,
          error: null,
        }));
        
        return { success: true, method: 'DELETE' };
      }
      
    } catch (error) {
      set(constructionSequenceAtom, (prev) => ({
        ...prev,
        loading: false,
        error: error.message || 'Failed to delete sequence',
      }));
      throw error;
    }
  }
);

export const getSequenceByBlockId = atom(
  (get) => (blockId) => {
    const state = get(constructionSequenceAtom);
    return state.sequences.find(seq => seq.block_id === blockId) || null;
  }
);

export const hasSequence = atom(
  (get) => (blockId) => {
    const state = get(constructionSequenceAtom);
    return state.sequences.some(seq => seq.block_id === blockId);
  }
);

export const saveConstructionSequences = updateConstructionSequences;